import { render } from "./CreateItFollowup.vue?vue&type=template&id=821273c8"
import script from "./CreateItFollowup.vue?vue&type=script&lang=js"
export * from "./CreateItFollowup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__